import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Toggle from 'react-toggle';
import Select from 'react-select';

class CertificationSplitTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
        overlay: {
            message: '',
            type: '',
            status: 'closed',        
        },
        redirect_url: false,
        loaded: 0,
        certification_id: this.props.certification_id,
        send_mail: false,
        new_certification_ids: [],
        certifications_options: [],
    };

    this.handleLoaded = this.handleLoaded.bind(this);

    this.split = this.split.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectMultiChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/certificados/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/certificados');
        if (responseJson.status === 'success') {
          self.setState({
            certifications_options: responseJson.data,
          });
        }
      });
    });
  }

  split(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');

    var datasave = {
      certification_id: this.state.certification_id,
      send_mail: this.state.send_mail,
      new_certification_ids: this.state.new_certification_ids,
    };

    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/desmembrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              send_mail: false,
              new_certification_ids: [],
            });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    var self = this;

    return (
      <div>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <h4>Desmembrar certificado</h4>
        <hr/>
        <form onSubmit={this.split}>
          <div className="row">
            <div className="col-md-4 form-group">
              <label>Enviar E-mails?</label>
              <br/>
              <Toggle
                checked={this.state.send_mail}
                aria-label='No label tag'
                name="send_mail"
                onChange={this.handleToggleChange.bind(this, 'send_mail')}
              />
            </div>
            <div className="col-md-8 form-group">
              <label>Certificados a serem gerados</label>
              <Select
                className="form-field-name"
                multi={true}
                name="new_certification_ids"
                value={this.state.new_certification_ids}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectMultiChange.bind(this, 'new_certification_ids')}
                options={this.state.certifications_options}
                required
              />
            </div>
          </div>
          <hr/>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Desmembrar</button>
        </form>
      </div>
    );
  }
  
}

export default CertificationSplitTab;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationSplitTab.js